/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Få Bumble",
      "Accepter alle",
      "administrer valgmuligheder",
      "Cookiepolitik",
      "Tilbage",
      "Forkert telefonnummer",
      "© {{current_year}} Bumble | Alle rettigheder forbeholdes",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Om",
      "Ambassadører",
      "Blog",
      "Vi benytter cookies. Hvis du ikke redigere dine indstillinger, så antager vi, at du er okay med dette.",
      "Download appen",
      "Download til Android",
      "Download til iOS",
      "Beklager, men vi kan ikke finde den side, du ledte efter.",
      "Log ind",
      "Tilmeld",
      "Tilslut dig kuben!",
      "Hovsa, noget gik galt"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dage",
                  "dages"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timer",
                  "timers"
            ],
            "singular": [
                  "time",
                  "times"
            ]
      },
      "minute": {
            "plural": [
                  "minutter",
                  "minutters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "måneder",
                  "måneders"
            ],
            "singular": [
                  "måned",
                  "måneds"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "årenes"
            ],
            "singular": [
                  "år",
                  "årets"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
